// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__21diQ","modalForm":"UpgradeEpcsModal_modalForm__342Zx","modalFooter":"UpgradeEpcsModal_modalFooter__2iFQa"};